import axios from 'axios'
import querystring from 'querystring'
import moment from 'moment'
// initial state

const state = {
  all: [],
  seasons: [],
  details: null,
  registrationEvents: null
}

// getters
const getters = {
  list: state => state.all,
  seasons: state => state.seasons,
  registrationEvents: state => state.registrationEvents,
  details: state => state.details,
  eventPosterPath: (state, getters, rootState, rootGetters) => rootGetters['config'].API.eventPosterPath
}

// actions
const actions = {
  getAll: function (context) {
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getAllEvents,
    // formData NO NATIVE SUPPORT
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password
      })
    )
    .then(
      (response) => {
        context.commit('SET_ALL_CURRENT', response.data)
        console.log(response)
      }
    )
    .catch((error) => console.log(error))
  },
  getSeasons: function (context) {
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getEventsBySeason,
    // formData NO NATIVE SUPPORT
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password
      })
    )
    .then(
      (response) => {
        context.commit('SET_SEASONS', response.data)
        console.log(response)
      }
    )
    .catch((error) => console.log(error))
  },
  getDetails: function (context, id) {
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getEventById,
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password,
        id: id
      })
    )
    .then(
      (response) => {
        context.commit('SET_DETAILS', response.data.country[0])
        console.log('setting details..')
        console.log(response)
      }
    )
    .catch((error) => console.log(error))
  }
}

// mutations
const mutations = {
  SET_ALL_CURRENT (state, data) {
    state.all = data.events
    console.log('SET_EVENTS')
    console.log(state.all)
  },
  SET_SEASONS (state, data) {
    data.seasons.forEach(element => {
      element.events.reverse()
    })
    if (data.seasons[0]) {
      state.registrationEvents = data.seasons[0].events.filter(x => x.show_result === '0' && x.show_competitor === '1' && moment().diff(moment(x.startDate), 'days') <= 0)
      data.seasons[0].events = data.seasons[0].events.filter(x => moment().diff(moment(x.startDate)) > 0)
    }
    state.seasons = data.seasons
    console.log('SET_SEASONS')
    console.log(state.seasons)
  },
  SET_DETAILS (state, data) {
    state.details = data
    console.log('SET_DETAILS')
    console.log(state.details)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
